import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { HttpClient,  HttpHeaders, HttpResponse } from '@angular/common/http';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { AlertController } from '@ionic/angular';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook/ngx';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators'; 

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class AuthProvider {

//  private headers = new HttpHeaders({ "x-api-key": this.refdata.getEnvVar('xapikey'), "Content-Type": "application/json" });
  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private plt: Platform,
    private refdata: RefdataProvider,
    /*private storage: Storage,*/
    private userData: UserDataProvider,
    public alertCtrl: AlertController,
    private googlePlus: GooglePlus, 
    private fb: Facebook,
    private bhutil: BhutilProvider) { }

  public isInApp(): boolean {
    let result: boolean = this.refdata.isInApp();
    console.log('AuthProvider.isInApp: ' + result);
    return result;
  }
  public isLoggedIn(): Promise<boolean> {
    return this.userData.isLoggedIn();
  }
  public isLoggedInValue(): boolean {
    return this.userData.isLoggedInValue();
  }
  public login(caller): boolean {
    if (!this.isInApp()) {
      let currentURL: string = this.plt.url(); // window.location.href;
      let split_url: string[] = currentURL.split('uid=');
      if (split_url.length > 1) {
        let passed_uid: string = split_url[split_url.length - 1];
        console.log('auth.login: passed_uid = ' + passed_uid);
        this.userData.login(passed_uid);
        caller.showSuccessPage();
        return true;
      }
      else {
        console.log('auth.login: no uid passed, trying code');
        let passed_code: string = this.getCodeFromURL(currentURL)
        /*
        let split_url: string[] = currentURL.split('code=');
        if (split_url.length > 1) {
        */
        if (passed_code && passed_code.length > 0) {
//          let passed_code: string = myCode; //string = split_url[split_url.length - 1];
          console.log('auth.login: passed_code = ' + passed_code);
          this.getUserAndContinue(passed_code, caller);
          return true;
        }
        else {
          console.log('auth.login: no uid nor code passed, redirecting to login');
          return false;
        }
      }
    }
  }

  public getLoginUrl(redirectUrl: string): string {
    let channel = (this.isInApp() ? 'app' : 'appinbrowser');
    let url: string = this.refdata.getEnvVar('loginBaseUrl') + '?response_type=code&client_id=' + this.refdata.getEnvVar('clientId') + '&redirect_uri=' + redirectUrl + '&channel=' + channel;
    console.log('loginUrl = ' + url);
    return url;
  }

  // Helper to configure POST body options using modern HttpClient structure
  private getOptions() {
      return { headers: this.headers };
  }

  public getUserAndContinue(code: string, caller) {
    //var result: string = '';
    //    let endpoint = "/getuserprofile";
    let endpoint = "/doProfile";
    let redirectUrl = this.getRedirectURL();

    let postUrl: string = this.refdata.getEnvVar('loginApiBaseUrl') + endpoint;
    console.log('getUserAndContinue: url to post to = ' + postUrl + ', code = ' + code);

    const options = {
            ...this.getOptions(),
            observe: 'response' as const, // Use 'as const' for strict typing
            responseType: 'json' as const
        };

    this.http.post(postUrl,
      { userid: 'unknownfromapp', latitude: 51.0, longitude: 4.0, code: code, redirectUrl: redirectUrl }, options)
      .subscribe(
        { next: (response: HttpResponse<Object>) => {
            // Read the result field from the JSON response.
            console.log('response status = ' + response.status + ', response = ' + response);
            if (response.ok && response.status == 200) {
              let responseObject: any = response.body as any;
              console.log(this.bhutil.stringify(responseObject));
              let userID = responseObject.id;
              console.log('auth.getUserAndContinue successfull, userID = ' + userID);
              if (this.refdata.isNonProd()) {
                this.bhutil.presentToast('Logged in with email/pwd as user ' + userID);
              }
            this.userData.login(userID).then(() => {
                caller.showSuccessPage();
              });
            }
            else {
              console.log('auth.getUserAndContinue failed, status = ' + response.statusText);
              this.logout().then(() => {
                caller.showNoAccessPage();
              });
            }
          },
            error: err => {
              //debugger;
              console.log('auth.getUserAndContinue failed, error = ' + err);
              this.logout().then(() => {
                caller.showNoAccessPage();
              });
          }
        }
      );
  }

  public logout(): Promise<void> {
    if (this.isLoggedInValue()) {
      if (this.loginProvider == "Google") {
        this.glogout();
      }
      if (this.loginProvider == "Facebook") {
        this.fblogout();
      }
    }
    return this.userData.logout().then(() => {
      if (!this.isInApp()) {
        let currentURL: string = window.location.href;
        let split_url: string[] = currentURL.split('uid=');
        if (split_url.length > 1) {
          currentURL = split_url[0];
        }
        split_url = currentURL.split('code=');
        if (split_url.length > 1) {
          currentURL = split_url[0];
        }
        window.open(currentURL, '_self');
      }
    });
  }

  public cleanURL(url: string): string {
    let result: string = url;
    console.log('cleanURL: result 1 = ' + result);
    let split_url: string[] = url.split('uid=');
    if (split_url.length > 1) {
      result = split_url[0];
      console.log('cleanURL: result 2 = ' + result);
    }
    split_url = result.split('code=');
    if (split_url.length > 1) {
      result = split_url[0];
      console.log('cleanURL: result 3 = ' + result);
    }
    let badLastCharacter: boolean = false;
    do {
      badLastCharacter = (result.charAt(result.length - 1) == '?');
      if (badLastCharacter) {
        result = result.substr(0, result.length - 1);
        console.log('cleanURL: result 4 = ' + result);
      }
    } while (badLastCharacter);
    console.log('cleanURL: result 5 = ' + result);
    return result;
  }

  public getCodeFromURL(url) {
    let result = '';
    let split_url = url.split('code=');
    if (split_url.length > 1) {
      result = split_url[1];
      console.log('getCodeFromURL: result = ' + result);
    }
    else {
      console.log('getCodeFromURL: no result in url ' + url);
    }
    if (result.endsWith('#_=_')) {
      result = result.replace('#_=_', '');
    }
    return result;
  }

  getRedirectURL() {
    if (this.isInApp()) {
      return 'http://localhost:8100/'
    }
    else {
      return this.cleanURL(this.plt.url());
    }
  }

  public upsertUserFromGoogle(googleResponse) {
    console.log('auth.upsertUserFromGoogle - googleResponse = ' + this.bhutil.stringify(googleResponse));
    /*
     * googleResponse looks like:
     * {"userId":"115876341978973670246",
     *  "displayName":"Koen Van Leuvenhaege",
     *  "imageUrl":"https://lh3.googleusercontent.com/-XdUIqdMkCWA/AAAAAAAAAAI/AAAAAAAAAAA/4252rscbv5M/s120/photo.jpg",
     *  "refreshToken":"1/z0BRlo4Mts7ioH_6AkgCFmLpYR6rEfMmsRtkkt76h5w",
     *  "email":"koen.van.leuvenhaege@gmail.com",
     *  "serverAuthCode":"",
     *  "accessToken":"ya29.GlyDBRp_csXyfo2n5qQcctgzh_9fGQoBqBtAigiRYjb88_rSdevqwXanDmoJUivWsd00b7TWVDS1iIs931dygQtUT4HGlueJuhAvXc6laTM92vwAJrQFXYOJ_ghSeA",
     *  "givenName":"Koen",
     *  "idToken":"eyJhbGciOiJSUzI1NiIsImtpZCI6ImM2ZjBlZTE2YmU3MGM0ODhkZDM5ZGI3MGY2ZjRkMTM3YTA0ODkxZTMifQ.eyJhenAiOiI1NzM0NjgwMTM4ODQtNnM5a2dqbHJqcm9oa2EwdGFncmdzNzZtZ3FlOHNlbDAuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJhdWQiOiI1NzM0NjgwMTM4ODQtNnM5a2dqbHJqcm9oa2EwdGFncmdzNzZtZ3FlOHNlbDAuYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJzdWIiOiIxMTU4NzYzNDE5Nzg5NzM2NzAyNDYiLCJlbWFpbCI6ImtvZW4udmFuLmxldXZlbmhhZWdlQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhdF9oYXNoIjoiZDFXREFvQjZsdTFBU2p6eXFaN2hKdyIsImV4cCI6MTUyMTQ3NjU2OSwiaXNzIjoiaHR0cHM6Ly9hY2NvdW50cy5nb29nbGUuY29tIiwiaWF0IjoxNTIxNDcyOTY5fQ.QLHx6f5rh3Gm5n0utxath7a-3YCvN6w9vExocJ3CSHb5bY1RVIFknnohqyaI_nLEfjqD_vDZJy5vTHtSZMnlXqpaLf0PtdkXliFUzK2muMW8YS8b0CDzpP4BLLjus_ai6YCwW_R4A3BOkemNs8FE0oiDIFe9RV6X5SLbze9agt0ISQ3vjAhm5q868zhN4RMtEdcn4Wf9uyVuEwFL32BEKW803sjIaUTIwcmW36wNnmmiy8Dy9lGltSZfq6Q8rSezFm0JozATo9aqIJWgkmpfzgrqIcCvzWc0rJPC81VhuPTyolZLPcJln4Aw2-IyUzjh9VaNsRvNnYZh47H2NJdphQ",
     *  "familyName":"Van Leuvenhaege"}
     */
    let user = {};
    user['id'] = 'Google_' + googleResponse.userId;
    user['userName'] = 'Google_' + googleResponse.userId;
    user['email'] = googleResponse.email;
    user['name'] = googleResponse.displayName;
    user['firstName'] = googleResponse.givenName;
    user['lastName'] = googleResponse.familyName;
    user['picture'] = googleResponse.imageUrl;

    this.upsertUser(user);
  }
  public upsertUserFromFacebook(facebookResponse) {
    console.log('auth.upsertUserFromFacebook - facebookResponse = ' + this.bhutil.stringify(facebookResponse));
    /*
     * facebookResponse looks like:
     * {"gender":"male",
     * "locale":"nl_NL",
     * "id":"10207453132206743",
     * "last_name":"Van Leuvenhaege",
     * "timezone":2,
     * "email":"koen.van.leuvenhaege@gmail.com",
     * "name":"Koen Van Leuvenhaege",
     * "first_name":"Koen"}
     */
    let user = {};
    user['id'] = 'Facebook_' + facebookResponse.id;
    user['userName'] = 'Facebook_' + facebookResponse.id;
    user['email'] = facebookResponse.email;
    user['name'] = facebookResponse.name;
    user['firstName'] = facebookResponse.first_name;
    user['lastName'] = facebookResponse.last_name;
    user['gender'] = facebookResponse.gender;
    user['locale'] = facebookResponse.locale;
    user['zoneInfo'] = facebookResponse.timezone;

    this.upsertUser(user);
  }

  public upsertUser(user) {
    let endpoint = "/upsertuser";

    const options = {
            ...this.getOptions(),
            observe: 'response' as const, // Use 'as const' for strict typing
            responseType: 'json' as const
        };

    let postUrl: string = this.refdata.getEnvVar('apiBaseUrl') + endpoint;
    console.log('auth.upsertUser: url to post to = ' + postUrl + ', user = ' + this.bhutil.stringify(user));

    this.http.post(postUrl,user, options)
      .subscribe({
        next: (response: HttpResponse<Object>) => {
              // Read the result field from the JSON response.
              console.log('auth.upsertUser: response status = ' + response.status + ', response = ' + this.bhutil.stringify(response.body));
              }
        ,
        error:   err => {
          console.log('auth.upsertUser failed, error = ' + err);
        }});

  }

  displayName: any;
  email: any;
  familyName: any;
  givenName: any;
  userId: any;
  imageUrl: any;

  loginProvider:string='';

  glogin(caller) {
    console.log('Calling Google login');
    this.googlePlus.login({
//      'webClientId': '573468013884-74kdt9j3ncha5c2p07r68ehu8gvqhdia.apps.googleusercontent.com'
//      'webClientId': 'com.googleusercontent.apps.573468013884-p1i43mshp3k59re18f4v137r7scjd2ht', //'573468013884-74kdt9j3ncha5c2p07r68ehu8gvqhdia.apps.googleusercontent.com',
//      'offline': true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
    })
      .then(res => {
        console.log(this.bhutil.stringify(res));
        this.displayName = res.displayName;
        this.email = res.email;
        this.familyName = res.familyName;
        this.givenName = res.givenName;
        this.userId = res.userId;
        this.imageUrl = res.imageUrl;

        this.loginProvider='Google';

        let localUserId = 'Google_' + res.userId;
        console.log('Google login with userid ' + localUserId);
        // console.log('Updating in AWS with res = ' + this.bhutil.stringify(res));
        // this.aws.loginAwsGoogle(res);
        console.log('Updating in DB with res = ' + this.bhutil.stringify(res));
        this.upsertUserFromGoogle(res);
        this.userData.login(localUserId).then(() => {
          console.log('Stored Google login with userid ' + localUserId);
          if (this.refdata.isNonProd()) {
            this.bhutil.presentToast('Logged in with Google as user ' + res.userId);
          }
        
          caller.loginCallback();

          // TODO update user profile on server
        });
    })
      .catch(err => {
        console.error(err);
        this.loginProvider = '';
        // last resort: try to go to Home page
        caller.loginCallback();
      });
  }

  glogout() {
    console.log('Calling Google logout');
    this.googlePlus.logout()
      .then(res => {
        console.log(res);
        this.displayName = "";
        this.email = "";
        this.familyName = "";
        this.givenName = "";
        this.userId = "";
        this.imageUrl = "";

        this.loginProvider = '';
      })
      .catch(err => console.error(err));
  }
  fblogin(caller) {
    console.log('Calling Facebook login');

this.fb.getLoginStatus().then((response) => {
  if (response.status === 'connected') {
    // the user is logged in and has authenticated your
    // app, and response.authResponse supplies
    // the user's ID, a valid access token, a signed
    // request, and the time the access token 
    // and signed request each expire
    let uid = response.authResponse.userID;
    let accessToken = response.authResponse.accessToken;

    let localUserId = 'Facebook_' + uid;
    console.log('Facebook already logged in with userid ' + localUserId);
    this.loginProvider = 'Facebook';
    this.userData.login(localUserId).then(() => {
      console.log('Stored Facebook login with userid ' + localUserId);
      if (this.refdata.isNonProd()) {
        this.bhutil.presentToast('Logged in with Facebook as user ' + uid);
      }
      caller.loginCallback();

      // TODO update user profile on server
    });

  } else { // (response.status === 'not_authorized') || (response.status == 'unknown')
    // the user isn't logged in to Facebook.

    this.fb.login(['public_profile', 'email'])
    .then((res: FacebookLoginResponse) => { 
      console.log('Logged into Facebook!', res);
      // this.userId = res.authResponse.userID;
      console.log('Facebook login: ' + this.bhutil.stringify(res));

      this.fb.api('/' + res.authResponse.userID + '?fields=id,name,email,first_name,last_name,gender,locale,timezone', ["public_profile", "email"])
        .then((profile: any) => {
          console.log('Facebook profile: ' + this.bhutil.stringify(profile));

          let localUserId = 'Facebook_' + profile.id;
          console.log('Facebook login with userid ' + localUserId);

          this.upsertUserFromFacebook(profile);

          this.loginProvider = 'Facebook';

          this.userData.login(localUserId).then(() => {
            console.log('Stored Facebook login with userid ' + localUserId);
            if (this.refdata.isNonProd()) {
              this.bhutil.presentToast('Logged in with Facebook as user ' + profile.id);
            }
            caller.loginCallback();

            // TODO update user profile on server
          });
            
          })
        .catch(e => {
          if (this.refdata.isNonProd()) {
            this.bhutil.presentToast('Error getting profile from Facebook: ' + this.bhutil.stringify(e));
          }
          console.log('Error getting profile from Facebook: ' + this.bhutil.stringify(e))
          this.loginProvider = '';
        });

    })
    .catch(e => { 
      this.loginProvider = '';
      console.log('Error logging into Facebook', e);
        // last resort: try to go to Home page
        caller.loginCallback();
    });




  }
}, (error) => {

});

  }
  fblogout() {
    console.log('Calling Facebook logout');
    this.fb.logout()
      .then(res => {
        console.log(res);
        this.displayName = "";
        this.email = "";
        this.familyName = "";
        this.givenName = "";
        this.userId = "";
        this.imageUrl = "";

        this.loginProvider = '';
      })
      .catch(err => console.error(err));
  }

}
